// extracted by mini-css-extract-plugin
module.exports = {"root":"Events_root__CsV1q","cardList":"Events_cardList__MA5Pa"};